import React, { memo } from 'react';
import { IconChevron } from 'gatorcomponents';
import * as Styles from './Pagination.styles';

const Pagination = memo(({
  currentPage,
  lastPage,
  perPage = 10,
  total = 0,
  onPageChange,
}) => {
  const calculatedLastPage = Math.ceil(total / perPage);
  const totalPages = Math.max(lastPage || 0, calculatedLastPage);

  if (totalPages <= 1) return null;

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <Styles.PageButton
          key={1}
          onClick={() => onPageChange(1)}
          type="button"
          $active={false}
          data-testid="pagination-page-1"
        >
          1
        </Styles.PageButton>,
      );
      if (startPage > 2) {
        pages.push(<Styles.Ellipsis key="ellipsis-start">...</Styles.Ellipsis>);
      }
    }

    for (let i = startPage; i <= endPage; i += 1) {
      pages.push(
        <Styles.PageButton
          key={i}
          onClick={() => onPageChange(i)}
          type="button"
          $active={i === currentPage}
          data-testid={`pagination-page-${i}`}
        >
          {i}
        </Styles.PageButton>,
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(<Styles.Ellipsis key="ellipsis-end">...</Styles.Ellipsis>);
      }
      pages.push(
        <Styles.PageButton
          key={totalPages}
          onClick={() => onPageChange(totalPages)}
          type="button"
          $active={false}
          data-testid={`pagination-page-${totalPages}`}
        >
          {totalPages}
        </Styles.PageButton>,
      );
    }

    return pages;
  };

  return (
    <Styles.PaginationWrapper data-testid="advanced-hosting-pagination">
      <Styles.Container>
        <Styles.NavigationButton
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
          type="button"
          data-testid="pagination-prev-button"
        >
          <IconChevron
            direction="left"
            size="md"
            color={currentPage === 1 ? 'highMedium' : 'primaryMedium'}
          />
        </Styles.NavigationButton>

        {renderPageNumbers()}

        <Styles.NavigationButton
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          type="button"
          data-testid="pagination-next-button"
        >
          <IconChevron
            direction="right"
            size="md"
            color={currentPage === totalPages ? 'highMedium' : 'primaryMedium'}
          />
        </Styles.NavigationButton>
      </Styles.Container>
    </Styles.PaginationWrapper>
  );
});

Pagination.displayName = 'Pagination';
export default Pagination;
